import { useState } from "react";
import SEO from "@/components/SEO";
import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Programs from "@/components/sections/Programs";
import Peptides from "@/components/sections/Peptides";
import Coach from "@/components/sections/Coach";
import Results from "@/components/sections/Results";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import BookingModal from "@/components/modals/BookingModal";
import PeptideInquiryModal from "@/components/modals/PeptideInquiryModal";
import MobileStickyBar from "@/components/MobileStickyBar";

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [bookingProgram, setBookingProgram] = useState(null);

  const [peptideOpen, setPeptideOpen] = useState(false);
  const [selectedPeptide, setSelectedPeptide] = useState(null);

  const openBooking = (program) => {
    setBookingProgram(typeof program === "string" ? program : null);
    setBookingOpen(true);
  };

  const openPeptide = (peptide) => {
    setSelectedPeptide(peptide);
    setPeptideOpen(true);
  };

  return (
    <div
      data-testid="home-page"
      className="bg-obsidian-900 text-white min-h-screen overflow-x-hidden"
    >
      <SEO />
      <Nav onBook={() => openBooking()} />
      <Hero onBook={() => openBooking()} />
      <Services />
      <Programs onBook={openBooking} />
      <Peptides onInquire={openPeptide} />
      <Coach />
      <Results />
      <FAQ />
      <Contact />
      <Footer />

      <BookingModal
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        defaultProgram={bookingProgram}
      />
      <PeptideInquiryModal
        open={peptideOpen}
        onOpenChange={setPeptideOpen}
        peptide={selectedPeptide}
      />

      <MobileStickyBar />
    </div>
  );
}
